import { CDN_URLS } from '../../constants/cdn-urls';
import { DefaultImageProps } from './types/index';

export const NoOfferBoxImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={`${CDN_URLS.WEB_SHOP}/general/no-offer-box.png`}
    alt="no-offer-box"
    {...props}
  />
);
